<template>
  <div class="mxMobileContent">
    <div class="title">{{$t('mxTitle')}}</div>
    <div class="desc">{{$t('mxLongContent')}}</div>
    <div class="qrcode">
      <canvas ref="mxMobileqrCode"></canvas>
      <img class="qrcode_icon" src="../assets/downloadImg/logo2.png" alt="">
    </div>
    <div class="downloadTips">{{$t('mx.scanCodeDown')}}</div>
    <div class="downloadBtn" @click="downloadMX">{{$t('downloadNow')}}</div>
  </div>
</template>
<script>
import QRCode from 'qrcode';
import device from '@/mx-service/libs/utils/device'
import { is4aLogin } from '@/mx-service/libs/utils';
import { getApiConfig } from '@/mx-service/libs/http/config'

export default {
  data(){
    return{
      qrCodeData: getApiConfig().defaultMobileUrl,
      qrCodeOptions: {
        width: 176,
        height: 176
      },
      isIOS: true,
      mxDownList: []
    }
  },
  methods: {
    async getData() {
      const data = await mx.request("getMobileUrl");
      return data
    },
    downloadMX(downloadParamId){
      if(device.isWechat()){
        this.$emit('showWX', true)
        return
      }
      console.log('downloadParamId---', downloadParamId)
      console.log('this.isIOS', this.isIOS)
      const type = this.isIOS ? 'MeiXin_ios_Link' : 'MeiXin_Android_Link'
      const status = is4aLogin(type, true)
      console.log('download-status', status)
      if(!status) return
      const data = this.mxDownList.filter(item => item.paramId === type)[0]
      window.location.href = data.paramValue;
    },
    async isDownloading(){
      const downloadParamId = this.$route.query.id
      if(is4aLogin() && downloadParamId && downloadParamId.toLowerCase().includes('meixin')){
        this.downloadMX(downloadParamId)
      }
    }
  },
  async mounted(){
    const isMobile = device.isMobile()

    // 判断当前设备类型
    this.isIOS = device.isIOS()
    console.log('mounter isIOS---', device.isIOS())
    // 判断单点登录状态
    const status = is4aLogin()
    console.log('MX 移动端 mounted-status', status)
    if((status && isMobile && window.location.pathname.indexOf("pcv5-4a.html") > -1) || device.isMission()) {
      const type = this.isIOS ? 'MeiXin_ios_Link' : 'MeiXin_Android_Link'
      this.mxDownList = await this.getData()
      this.qrCodeData = this.mxDownList && this.mxDownList.length>0 && this.mxDownList.filter(item => item.paramId === type)[0].paramValue
    }

    // 判断是否有下载进程
    await this.isDownloading()

    QRCode.toCanvas(this.$refs.mxMobileqrCode, this.qrCodeData, this.qrCodeOptions, function (error) {
      if (error) console.error(error);
    });

  }
}
</script>
<style lang="less" scoped>
.mxMobileContent {
  padding-top: 42px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .title {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #191919;
    line-height: 45px;
  }
  .desc {
    margin-top: 4px;
    font-size: 18px;
    color: #666666;
    line-height: 25px;
  }
  .qrcode {
    margin-top: 28px;
    width: 176px;
    height: 176px;
    position: relative;
    z-index: 49;
    .qrcode_icon {
      position: absolute;
      z-index: 50;
      width: 40px;
      height: 40px;
      left: calc(50% - 20px);
      top: calc(50% - 20px);
    }
  }
  .downloadTips {
    margin-top: 8px;
    font-size: 14px;
    color: #999999;
    line-height: 18px;
  }
  .downloadBtn {
    background: #2496FF;
    border-radius: 22px;
    width: 244px;
    height: 44px;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 28px;
  }

}
</style>